import { useQuery } from 'convex/react';
import { api } from '../../../convex/_generated/api';

export interface CoachAnalytics {
  overallStats: {
    avgEffort: number;
    avgEngagement: number;
    avgCompetition: number;
    avgAttitude: number;
    totalEvaluations: number;
  } | null;
  chartData: Array<{
    date: string;
    effort: number;
    engagement: number;
    competitionLevel: number;
    attitude: number;
    count: number;
  }>;
  topPerformers: Array<{
    playerId: string;
    name: string;
    overall: number;
    effort: number;
    engagement: number;
    competitionLevel: number;
    attitude: number;
    evalCount: number;
  }>;
  needsAttention: Array<{
    playerId: string;
    name: string;
    overall: number;
    effort: number;
    engagement: number;
    competitionLevel: number;
    attitude: number;
    evalCount: number;
  }>;
}

export function useCoachStats() {
  const data = useQuery(api.coach.stats.get);
  return { data, isLoading: data === undefined, error: null };
}

export function useCoachAnalytics() {
  const data = useQuery(api.coach.analytics.get);
  return { data, isLoading: data === undefined, error: null };
}

export interface DrillFrequencyEntry {
  drill: string;
  count: number;
}

export function useCoachDrillFrequency(days?: number, topN?: number) {
  const data = useQuery(api.coach.analytics.getDrillFrequency, { days, topN });
  return { data, isLoading: data === undefined };
}
